import { Organization } from '@cast/types';

import { useRemoveUserFromOrganizationDialog as useRemoveUserFromOrganizationDialogBase } from '../../management/hooks/useRemoveUserFromOrganizationDialog/useRemoveUserFromOrganizationDialog';
import { Member } from '@cast/features-organization-shared-types';

export const useRemoveUserFromOrganizationDialog = () => {
  const { openModal: openModalBase } =
    useRemoveUserFromOrganizationDialogBase();

  const openModal = (
    organization: Organization,
    { id, userName }: { id: string; userName: string },
    isMe: boolean
  ) => {
    openModalBase({
      organization,
      members: [{ id, name: userName } as Member],
      isMe,
      onSuccessfulRemove: undefined,
    });
  };

  return { openModal };
};
